import colors from './themes'
import { defineVuesticConfig } from 'vuestic-ui'

export default defineVuesticConfig({
  colors,
  breakpoint: {
    enabled: true,
    bodyClass: true,
    thresholds: {
      xs: 0,
      sm: 320,
      md: 640,
      lg: 1024,
      xl: 1440,
    },
  },
  components: {
    presets: {
      VaInput: {
        widget: {
          class: 'wg-input',
          rounded: false,
          bordered: true,
        },
      },
      VaSelect: {
        widget: {
          class: 'wg-select',
          rounded: false,
          bordered: true,
          color: 'primary',
          anchorClass: 'wg-select-anchor',
        },
      },
      VaDateInput: {
        widget: {
          class: 'wg-date-input',
          rounded: false,
          bordered: true,
          color: 'primary',
        },
      },
      VaButton: {
        widgetPrimary: {
          color: 'primary',
          rounded: false,
        },
      },
    },
  },
})
